/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyWebhookStatus } from './CompanyWebhookStatus';
import {
    CompanyWebhookStatusFromJSON,
    CompanyWebhookStatusFromJSONTyped,
    CompanyWebhookStatusToJSON,
    CompanyWebhookStatusToJSONTyped,
} from './CompanyWebhookStatus';
import type { CompanyWebhookEventType } from './CompanyWebhookEventType';
import {
    CompanyWebhookEventTypeFromJSON,
    CompanyWebhookEventTypeFromJSONTyped,
    CompanyWebhookEventTypeToJSON,
    CompanyWebhookEventTypeToJSONTyped,
} from './CompanyWebhookEventType';

/**
 * A webhook configured on the company, as the customer may see it. Never carries the signing secret nor the extra request headers, which may hold credentials.
 * @export
 * @interface WebhookSummary
 */
export interface WebhookSummary {
    /**
     * 
     * @type {string}
     * @memberof WebhookSummary
     */
    companyWebhookId: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSummary
     */
    webhookUrl: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSummary
     */
    description?: string;
    /**
     * 
     * @type {CompanyWebhookStatus}
     * @memberof WebhookSummary
     */
    status: CompanyWebhookStatus;
    /**
     * 
     * @type {boolean}
     * @memberof WebhookSummary
     */
    subscribeToAllEvents: boolean;
    /**
     * Empty when subscribeToAllEvents is true.
     * @type {Array<CompanyWebhookEventType>}
     * @memberof WebhookSummary
     */
    eventTypes: Array<CompanyWebhookEventType>;
    /**
     * 
     * @type {Date}
     * @memberof WebhookSummary
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebhookSummary
     */
    lastTriggeredAt?: Date;
    /**
     * Consecutive failed deliveries. Resets on the next success.
     * @type {number}
     * @memberof WebhookSummary
     */
    failureCount: number;
}



/**
 * Check if a given object implements the WebhookSummary interface.
 */
export function instanceOfWebhookSummary(value: object): value is WebhookSummary {
    if (!('companyWebhookId' in value) || value['companyWebhookId'] === undefined) return false;
    if (!('webhookUrl' in value) || value['webhookUrl'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('subscribeToAllEvents' in value) || value['subscribeToAllEvents'] === undefined) return false;
    if (!('eventTypes' in value) || value['eventTypes'] === undefined) return false;
    if (!('failureCount' in value) || value['failureCount'] === undefined) return false;
    return true;
}

export function WebhookSummaryFromJSON(json: any): WebhookSummary {
    return WebhookSummaryFromJSONTyped(json, false);
}

export function WebhookSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'companyWebhookId': json['companyWebhookId'],
        'webhookUrl': json['webhookUrl'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': CompanyWebhookStatusFromJSON(json['status']),
        'subscribeToAllEvents': json['subscribeToAllEvents'],
        'eventTypes': ((json['eventTypes'] as Array<any>).map(CompanyWebhookEventTypeFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'lastTriggeredAt': json['lastTriggeredAt'] == null ? undefined : (new Date(json['lastTriggeredAt'])),
        'failureCount': json['failureCount'],
    };
}

  export function WebhookSummaryToJSON(json: any): WebhookSummary {
      return WebhookSummaryToJSONTyped(json, false);
  }

  export function WebhookSummaryToJSONTyped(value?: WebhookSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyWebhookId': value['companyWebhookId'],
        'webhookUrl': value['webhookUrl'],
        'description': value['description'],
        'status': CompanyWebhookStatusToJSON(value['status']),
        'subscribeToAllEvents': value['subscribeToAllEvents'],
        'eventTypes': ((value['eventTypes'] as Array<any>).map(CompanyWebhookEventTypeToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'lastTriggeredAt': value['lastTriggeredAt'] == null ? undefined : ((value['lastTriggeredAt']).toISOString()),
        'failureCount': value['failureCount'],
    };
}

